import { Stack, Typography, Box } from "@mui/material";
import React, { FC } from "react";
import { useWatch } from "react-hook-form";
import { WebShopIcon } from "../../WebShopIcon";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { MobileColumnItemProps } from "../lib/type";
import { ProposalTableColumnFieldTypes } from "@/src/shared/schemas";
import { useProposalTableContext } from "./ProposalTableProvider";

export const MobileColumnItem: FC<MobileColumnItemProps> = ({
  name,
  fieldItem,
}: MobileColumnItemProps) => {
  const { form: { control }} = useProposalTableContext();
  const selectValue = useWatch({ name, control });
  if (fieldItem.type === "checkLabel") {
    return (
      <Stack className="gap-2 flex-center-row">
        <Box className="flex">
          <WebShopIcon
            name={fieldItem.status === "positive" ? "check" : "close"}
            className={cn("h-[17px] w-[17px] fill-dark-gray", {
              "fill-blue": fieldItem.status === "positive",
            })}
          />
        </Box>
        <Typography className="text-center font-semibold">{fieldItem.label}</Typography>
      </Stack>
    );
  }

  if (
    fieldItem.type === ProposalTableColumnFieldTypes.SelectNumber ||
    fieldItem.type === ProposalTableColumnFieldTypes.SelectCurrency ||
    fieldItem.type === ProposalTableColumnFieldTypes.SelectNumberCurrency
  ) {
    return (
      <Typography className="text-center font-semibold" variant="body1">
        {selectValue?.label ?? selectValue}
      </Typography>
    );
  }

  return (
    <Typography className="text-center font-semibold" variant="body1">
      {fieldItem?.label}
    </Typography>
  );
};
